import React, { Component } from 'react';
import SprintService from '../service/sprintService';
import SprintStatusService from "../service/sprintStatusService";
import TaskService from '../service/taskService';
import TaskStatusService from '../service/taskStatusService';
import TaskListWithCheckbox from '../components/tasklistWithCheckbox';
import NavigationBar from '../components/navigationBar';
import TaskTypeService from '../service/taskTypeService';

export default class BacklogOverviewSite extends Component {

    constructor(props) {
        super(props);
        this.sprintService = new SprintService();
        this.sprintStatusService = new SprintStatusService();
        this.taskService = new TaskService();
        this.taskStatusService = new TaskStatusService();
        this.taskTypeService = new TaskTypeService();
        this.state = {
            tasks: [],
            taskStatuses: [],
            selectedTasks: [],
            sprints: [],
            selectedSprint: "",
            newSprintStatus: 0,
            TaskTitle: "",
            TaskDescription: "",
            NoRedirect: false,
            SubmittingTask: false,
            tasktypes: [],
            selectedTaskType: 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleCheckBoxArrayChange = this.handleCheckBoxArrayChange.bind(this);
        this.addTasksToSelectedSprint = this.addTasksToSelectedSprint.bind(this);
    }

    async getTaskStatuses() {
        let result = await this.taskStatusService.getTaskStatuses();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    async getOpenSprints() {
        let result = await this.sprintService.retrieveOpenSprints(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                sprints: result
            })
        }
    }

    async getTasksInBacklog() {
        let result = await this.taskService.getTasksInBacklog(this.props.match.params.projectID);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasks: result
            })
        }
    }


    async addTasksToSelectedSprint(event) {
        event.preventDefault();

        let result = await this.sprintService.addTasksToSprint(this.state.selectedSprint, this.state.selectedTasks);
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("You have added " + this.state.selectedTasks.length + " tasks to the selected sprint")
            this.state = {
                selectedTasks: []
            }
            this.getTasksInBacklog();
        }
    }


    handleCheckBoxArrayChange(event, taskUUID) {
        let existsIndex = this.state.selectedTasks.indexOf(taskUUID);
        if (event.target.checked) {
            if (existsIndex === -1) {
                let array = this.state.selectedTasks;
                array.push(taskUUID);
                this.setState(() => ({ selectedTasks: array }))
            };
        }
        else {
            if (existsIndex !== -1) {
                let array = this.state.selectedTasks;
                array.splice(existsIndex, 1);
                this.setState(() => ({ selectedTasks: array }))
            }
        }
    }

    async getTaskTypes() {
        let result = await this.taskTypeService.getTaskTypes();
        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                tasktypes: result
            })
        }
    }

    componentDidMount() {
        this.getTaskStatuses();
        this.getTasksInBacklog();
        this.getOpenSprints();
        this.getTaskTypes();
    }


    handleChange({ target }) {
        this.setState({
            [target.name]: target.value
        });
    }

    handleCheckBoxChange() {
        this.setState({
            NoRedirect: !this.state.NoRedirect
        })
    }

    showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

    hideOverlay() {
        document.getElementById("overlay").style.display = "none";
    }

    async onSubmitClick(event) {
        event.preventDefault();
        this.setState({
            SubmittingTask: true
        })

        let results = await this.taskService.createTask(this.props.match.params.projectID, this.state.TaskTitle, this.state.TaskDescription, this.state.selectedTaskType);
        if (results.statuscode === 200) {
            if (!this.state.NoRedirect) {
                this.hideOverlay();
            }
            else {
                alert("Your task \"" + this.state.TaskTitle + "\" have been created");
                this.setState({
                    TaskTitle: "",
                    TaskDescription: "",
                    SubmittingTask: false
                })
            }
            this.getTasksInBacklog();

        }
        else if (results.statuscode === 401) {
            this.props.history.push("/Login");
        }
        else {
            alert("Your task have not been created. Error code: " + results.body.code + "Error message:" + results.body.message);
            this.setState({
                SubmittingTask: false
            })
        }
    }

    render() {
        const tasks = this.state.tasks;
        if (!tasks) return null;
        const taskStatuses = this.state.taskStatuses;
        if (taskStatuses.length === 0) return null;
        const sprints = this.state.sprints;
        if (!sprints) return null;
        const tasktypes = this.state.tasktypes;
        if (tasktypes.length === 0) return null;

        return (
            <div className="body">

                <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Task</h1></center>
                        <form action="#" onSubmit={(event) => { this.onSubmitClick(event) }}>
                            <select name="selectedTaskType" id="selectedTaskType" onChange={this.handleChange} value={this.state.taskTypeStatus}>
                                {tasktypes.map(tasktype => (
                                    <option value={tasktype.typeId} key={tasktype.typeId}>{tasktype.typeName}</option>
                                ))}
                            </select><br />
                            <label htmlFor="TaskTitle"><b>Title:</b></label><br />
                            <input type="text" name="TaskTitle" value={this.state.TaskTitle} onChange={this.handleChange} required /><br />
                            <label htmlFor="TaskDescription"><b>Description:</b></label><br />
                            <textarea name="TaskDescription" id="TaskDescription" value={this.state.TaskDescription} onChange={this.handleChange} cols="50" rows="4"></textarea><br />
                            <label htmlFor="NoRedirect"><b>Create Multiple:</b></label>
                            <input type="checkbox" name="NoRedirect" defaultChecked={this.state.NoRedirect} onChange={() => this.handleCheckBoxChange()} /><br />
                            <button type="submit" disabled={this.state.SubmittingTask}>Create Task</button>
                        </form>
                    </div>
                </div>

                <NavigationBar {...this.props} />


                <main>
                    <button onClick={this.showOverlay}>Create New</button>
                    <form action="#" onSubmit={(event) => { this.addTasksToSelectedSprint(event) }}>

                        <select name="selectedSprint" id="selectedSprint" onChange={this.handleChange} value={this.state.selectedSprint}>
                            <option disabled={true} value={""}> -- select an option -- </option>
                            {sprints.map(sprint => (
                                <option value={sprint.sprintUUID} key={sprint.sprintUUID}>{sprint.sprintName}</option>
                            ))}
                        </select>
                        <button >Add tasks to sprint</button>
                    </form>

                    <p>Tasks in Backlog</p>
                    <TaskListWithCheckbox tasks={this.state.tasks} taskStatuses={this.state.taskStatuses} projectUUID={this.props.match.params.projectID} SelectedTasksCallBack={this.handleCheckBoxArrayChange} />
                </main>


            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/sites/BacklogOverviewSite.js